// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"3f2f3cd9","990":"07b060f0"}[chunkId] + ".chunk.css";
};